import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faYoutube, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faMapMarkerAlt, faPhone, faClock } from '@fortawesome/free-solid-svg-icons';

const quickLinks = [
  { href: '#home', label: 'Início' },
  { href: '#about', label: 'Nossa História' },
  { href: '#schedules', label: 'Cultos' },
  { href: '#gcs', label: 'Grupos de Crescimento' },
  { href: '#sermons', label: 'Mensagens' },
  { href: '#contact', label: 'Contato' },
];

const scheduleItems = [
  { day: 'Domingos', times: '10h · 17h · 19h30' },
  { day: 'Segundas', times: '20h — Culto HOPE' },
  { day: 'Quartas', times: '20h — Culto FÉ' },
];

const socials = [
  { icon: faFacebookF, href: 'https://facebook.com', label: 'Facebook' },
  { icon: faInstagram, href: 'https://www.instagram.com/igrejalagoinhacidadeverde/', label: 'Instagram' },
  { icon: faYoutube, href: 'https://www.youtube.com/@lagoinhacidadeverde', label: 'YouTube' },
  { icon: faWhatsapp, href: 'https://wa.me/5584996632025', label: 'WhatsApp' },
];

const Footer = () => {
  return (
    <footer className="bg-[#070b14] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* Coluna 1 — Marca */}
          <div>
            <div className="flex items-center gap-3 mb-5">
              <img
                src="/images/64382eb8c029a.png"
                alt="Igreja Lagoinha"
                className="h-14 w-14 rounded-full object-cover ring-2 ring-yellow-500/20"
              />
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-6">
              Grande para servir e pequena para se importar. Parte da Lagoinha Global — quase 700 igrejas pelo mundo.
            </p>
            <div className="flex gap-3">
              {socials.map(({ icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="w-9 h-9 rounded-lg bg-white/5 border border-white/8 flex items-center justify-center text-gray-500 hover:text-yellow-400 hover:border-yellow-500/30 transition-all duration-200 text-sm"
                >
                  <FontAwesomeIcon icon={icon} />
                </a>
              ))}
            </div>
          </div>

          {/* Coluna 2 — Links rápidos */}
          <div>
            <h4 className="text-white text-sm font-bold uppercase tracking-widest mb-5">
              Links Rápidos
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map(({ href, label }) => (
                <li key={href}>
                  <a
                    href={href}
                    className="text-gray-500 hover:text-yellow-400 text-sm transition-colors"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Coluna 3 — Horários */}
          <div>
            <h4 className="text-white text-sm font-bold uppercase tracking-widest mb-5">
              Programação
            </h4>
            <ul className="space-y-4">
              {scheduleItems.map(({ day, times }) => (
                <li key={day} className="flex items-start gap-3">
                  <FontAwesomeIcon icon={faClock} className="text-yellow-500/60 text-xs mt-1" />
                  <div>
                    <p className="text-white text-sm font-medium">{day}</p>
                    <p className="text-gray-500 text-xs mt-0.5">{times}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Coluna 4 — Localização */}
          <div>
            <h4 className="text-white text-sm font-bold uppercase tracking-widest mb-5">
              Onde Estamos
            </h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <FontAwesomeIcon icon={faMapMarkerAlt} className="text-yellow-500/60 text-xs mt-1" />
                <p className="text-gray-500 text-sm leading-relaxed">
                  Av. Dep. Gastão Mariz de Faria<br />
                  Nova Parnamirim, Parnamirim · RN<br />
                  CEP 59152-250
                </p>
              </div>
              <div className="flex items-center gap-3">
                <FontAwesomeIcon icon={faPhone} className="text-yellow-500/60 text-xs" />
                <a
                  href="https://wa.me/5584996632025"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-500 hover:text-emerald-400 text-sm transition-colors"
                >
                  (84) 99663-2025
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Barra inferior */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-gray-600 text-xs">
            &copy; {new Date().getFullYear()} Igreja Lagoinha Cidade Verde. Todos os direitos reservados.
          </p>
          <p className="text-gray-700 text-xs">
            Desenvolvido por{' '}
            <a
              href="https://instagram.com/ocaiomoises"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-yellow-500 transition-colors"
            >
              @ocaiomoises
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
